import { render, staticRenderFns } from "./MyCalculations.vue?vue&type=template&id=0a960c4e&scoped=true"
import script from "./MyCalculations.vue?vue&type=script&lang=js"
export * from "./MyCalculations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a960c4e",
  null
  
)

export default component.exports